import App from './App';
import i18n from './i18n';
import { Spin } from 'antd';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next';
import { persistor, store } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import LoadingIconApp from './components/loadingIconApp/LoadingIconApp';
import colors from './styles/Color.scss';
import './styles/index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));

const antIcon = (
  <LoadingIconApp
    size={26}
    style={{ fontSize: 26, color: colors.primaryColor }}
  />
);

Spin.setDefaultIndicator(antIcon);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </PersistGate>
  </Provider>
);

reportWebVitals();
